import { Link } from "react-router-dom";
import { forumList } from "@/mocks/forum";
import SectionHeading from "./SectionHeading";

export default function HotForum() {
  const items = [...forumList].sort((a, b) => b.replies - a.replies).slice(0, 5);
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
      <SectionHeading icon="ri-fire-line" title="热门论坛话题" subtitle="邻里们正在热议" moreTo="/forum" />
      <ol className="space-y-3">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link to={`/forum/${item.id}`} className="group flex gap-3">
              <span
                className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${
                  i < 3 ? "bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-500"
                }`}
              >
                {i + 1}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-1 text-xs text-foreground-400">
                  <span className="px-1.5 py-0.5 rounded bg-secondary-50 text-secondary-700">{item.section}</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{item.replies}</span>
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{item.views}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}